import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { Button, Spin, Result } from "antd";

const ZohoAuthenticate = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [connectorId, setConnectorId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state"); // will contain "configId:xxx;connectorId:yyy"

    let connectionId = null;
    let connectorIdParam = null;

    if (state) {
      const stateParts = state.split(";");
      stateParts.forEach((part) => {
        const [key, value] = part.split(":");
        if (key === "configId") connectionId = value;
        if (key === "connectorId") connectorIdParam = value;
      });
    }

    setConnectorId(connectorIdParam);

    if (code && connectionId) {
      const callBackend = async () => {
        try {
          const apiService = new ApiService(
            `${BASE_URL}/connector_configs/${connectionId}/get_access_token_by_code`,
            { "Content-Type": "application/json" },
            "POST",
            JSON.stringify({ code })
          );
          await apiService.makeCall();
          setSuccess(true);
        } catch (err) {
          console.error(err);
          setSuccess(false);
        } finally {
          setLoading(false);
        }
      };
      callBackend();
    } else {
      setLoading(false);
      setSuccess(false);
    }
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "20%" }}>
        <Spin size="large" tip="Authenticating..." />
      </div>
    );
  }

  return success ? (
    <Result
      status="success"
      title="Authentication Successful"
      subTitle="Your tokens have been saved successfully."
      extra={[
        connectorId && (
          <Button
            type="primary"
            key="setup"
            onClick={() =>
              navigate(`/setup/CustomConnectors/${connectorId}`)
            }
          >
            Go to Connector Setup
          </Button>
        ),
        <Button key="home" onClick={() => navigate("/")}>
          Go to Home
        </Button>,
      ]}
    />
  ) : (
    <Result
      status="error"
      title="Authentication Failed"
      subTitle="Unable to save tokens. Please try again."
      extra={[
        <Button key="retry" onClick={() => navigate("/")}>
          Retry
        </Button>,
      ]}
    />
  );
};

export default ZohoAuthenticate;
